<template>
  <div class="d-flex flex-column" :key="key">
    <div v-if="!hasConversation" class="flex-grow-1 d-flex justify-content-center align-items-center">
      <h5 class="text-muted-light">No conversation selected</h5>
    </div>
    <div v-else :style="styles" class="chat-viewer flex-grow-1 d-flex flex-column">
      <info-panel
          :conversation="current"
          class="flex-shrink-0 flex-grow-0"
      ></info-panel>
      <chat
          ref="chat"
          :adaptive-refresh="true"
          :auto-refresh="true"
          :types="types"
          :conversation="current"
          :index-url="current.message_index_url"
          class="flex-shrink-0 flex-grow-1"
          :styles="styles"
          :index-media-url="indexMediaUrl"
          :store-media-url="storeMediaUrl"
          :can-create-media="canCreateMedia"
      ></chat>
    </div>
  </div>
</template>

<script>
import eventBus from "../../event-bus";
import InfoPanel from "./chat-info-panel";
import CallDialog from "../../components/call/call-dialog";

export default {
  components: {
    InfoPanel,
    CallDialog
  },

  props: {
    types: Object,
    indexMediaUrl: String,
    storeMediaUrl: String,
    canCreateMedia: Boolean,
  },

  data() {
    return {
      current: null,
    };
  },

  computed: {
    /**
     * @return {number}
     */
    key() {
      return _.get(this.current, 'id', 0);
    },

    /**
     * @return {Object|null}
     */
    brand() {
      return _.get(this.current, 'outgoing_number.brand', null);
    },

    /**
     * @return {Object}
     */
    styles() {
      const {
        'container.background.color': backgroundColor
      } = this.brand ? _.assign({}, this.brand.styles) : {};

      return _.pickBy({backgroundColor}, _.identity);
    },

    /**
     * @return {boolean}
     */
    hasConversation() {
      return Boolean(this.current);
    },
  },

  methods: {
    /**
     * @param {Object} val
     */
    onConversationListChange(val) {
      this.current = val;
    },

    /**
     * @param {Object} message
     */
    onQuickMessageSent({conversation_id}) {
      if (conversation_id === _.get(this.current, 'id', null)) {
        this.$refs.chat.refresh();
      }
    },
  },

  mounted() {
    eventBus.$on('conversation-list-change', this.onConversationListChange);
    eventBus.$on('quick-message-sent', this.onQuickMessageSent);
  },

  beforeDestroy() {
    eventBus.$off('conversation-list-change', this.onConversationListChange);
    eventBus.$off('quick-message-sent', this.onQuickMessageSent);
  },
}
</script>
